import formatToServer from "@/components/ui/services/date-format/formatToServer";

const defaultEvent = {
    id: null,
    name: '',
    theme: '',
    age: '',
    started_reg_at: null,
    started_at: null,
    ended_at: null,
    description: '',
    cost: '',
    coupons: [],
    questions: []
};

import createQuestions from "@/store/event/questions";

const save_formats = {
    'started_reg_at': formatToServer,
    'started_at': formatToServer,
    'ended_at': formatToServer
}

export default eventsApi => {
    return {
        namespaced: true,
        state: {
            event: {},
            modifyFields: {},
            errors: {}
        },
        getters: {
            errors: state => state.errors,

            id: state => state.event.id,
            name: state => state.event.name,
            theme: state => state.event.theme,
            age: state => state.event.age,
            started_reg_at: state => state.event.started_reg_at,
            started_at: state => state.event.started_at,
            ended_at: state => state.event.ended_at,
            description: state => state.event.description,
            cost: state => state.event.cost,

            coupons: state => state.event.coupons,

            isModify: state => Object.keys(state.modifyFields).length !== 0,
            //isNew: state => !state.event.id > 0,

        },
        mutations: {
            setEvent(state, event) {
                if (event.id) {
                    event['started_reg_at'] = new Date(event['started_reg_at'] ?? Date.now())
                    event['started_at'] = new Date(event['started_at']?? Date.now())
                    event['ended_at'] = new Date(event['ended_at']?? Date.now())
                }
                state.event = event;
                state.modifyFields = {};
                state.errors = {};
            },
            setField(state, {field, value}) {
                state.event[field] = value;

                if (field in save_formats) {
                    value = save_formats[field](value);
                }
                console.log(value)
                state.modifyFields[field] = value;
            },
            removeCoupon(state, coupon) {
                let index = state.event.coupons.findIndex(el => el.id === coupon.id);
                if (index !== -1) {
                    state.event.coupons.splice(index, 1)
                }
            },
            postCoupon(state, coupon) {
                state.event.coupons.push(coupon);
            },
            setErrors(state, errors) {
                state.errors = errors;
            }

        },
        actions: {
            async load({commit, dispatch}, id) {

                if (id !== 'new') {
                    let event = await eventsApi.get(id);
                    commit('setEvent', event);
                    dispatch('questions/load', event.questions)
                } else {
                    commit('setEvent', {...defaultEvent})
                    dispatch('questions/load', [])
                }

            },
            async save({commit, state, dispatch}) {
                try {
                    const event = await eventsApi.patch(state.event.id, state.modifyFields)
                    commit('setEvent', event);
                    dispatch('alerts/success', {text: 'Внесенные изменения сохранены.'}, {root: true});
                    return event;
                } catch (errors) {
                    commit('setErrors', errors);
                }
                return {}

            },
            async removeCoupon({state, commit, dispatch}, id) {
                try {
                    const coupon = await eventsApi.removeCoupon(state.event.id, id)
                    commit('removeCoupon', coupon);
                    dispatch('alerts/success', {text: 'Купон удален.'}, {root: true});
                } catch (errors) {
                    commit('setErrors', errors);
                }
            },
            async postCoupon({state, commit, dispatch}, {code, discount}) {
                try {
                    const coupon = await eventsApi.postCoupon(state.event.id, code, discount)
                    commit('postCoupon', coupon);
                    dispatch('alerts/success', {text: 'Купон добавлен.'}, {root: true});
                } catch (errors) {
                    commit('setErrors', errors);
                }
            }

        },
        modules: {
            questions: createQuestions(eventsApi),
        }
    }
}